import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: _ctx.$vuetify.display.smAndDown ? '80vw' : '40vw' })
  }, [
    _createElementVNode("div", null, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_v_form, {
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valid) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "7",
              class: "pr-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"border":"1px #ededed solid","border-radius":"15px"},
                  class: "pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select_filled, {
                          modelValue: _ctx.bankAccountId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bankAccountId) = $event)),
                          items: _ctx.filteredBankAccounts,
                          "item-title": "name",
                          "item-value": "id",
                          label: 
                                    _ctx.paymentType === 'CUSTOMER'
                                        ? 'Compte à créditer'
                                        : 'Compte à débiter'
                                ,
                          readonly: _ctx.readOnly,
                          mandatory: true,
                          "hide-details": "auto",
                          rules: [
                                    (v) =>
                                        _ctx.paymentType === 'PAYMENT_CREDIT' ||
                                        !!v ||
                                        'Compte bancaire requis',
                                ],
                          density: "compact"
                        }, null, 8, ["modelValue", "items", "label", "readonly", "rules"])
                      ]),
                      _: 1
                    }),
                    (_ctx.paymentType !== 'CUSTOMER')
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          class: "pt-2",
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.paymentType !== 'PAYMENT_CREDIT')
                              ? (_openBlock(), _createBlock(_component_v_combobox_filled, {
                                  key: 0,
                                  modelValue: _ctx.iban,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.iban) = $event)),
                                  label: "IBAN bénéficiaire",
                                  rules: [(v) => _ctx.isIbanOK || 'Mauvais format'],
                                  "hide-details": "auto",
                                  items: _ctx.thirdCompanyData.ibans,
                                  "item-title": "iban",
                                  "item-value": "iban",
                                  readonly: _ctx.readOnly
                                }, null, 8, ["modelValue", "rules", "items", "readonly"]))
                              : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                  key: 1,
                                  value: "bobbee",
                                  label: "Bénéficiaire",
                                  "hide-details": "auto",
                                  readonly: ""
                                }))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.websites.length)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "12",
                          class: "pt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.budgetInsightWebsiteField,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.budgetInsightWebsiteField) = $event)),
                              items: _ctx.websites,
                              "item-title": "label",
                              "item-value": "value",
                              label: _ctx.websiteFieldLabel,
                              "hide-details": "auto",
                              readonly: _ctx.readOnly
                            }, null, 8, ["modelValue", "items", "label", "readonly"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "5",
              class: "pl-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  style: {"border":"1px #ededed solid","border-radius":"15px"},
                  class: "pa-2",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.description,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                          label: "Motif du paiement",
                          "hide-details": "auto",
                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                          readonly: _ctx.readOnly,
                          density: "compact"
                        }, null, 8, ["modelValue", "rules", "readonly"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "py-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.paymentType === 'PAYMENT_CREDIT')
                          ? (_openBlock(), _createBlock(_component_v_select_filled, {
                              key: 0,
                              modelValue: _ctx.paymentCreditCount,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentCreditCount) = $event)),
                              items: [10, 25, 50, 100, 200, 400, 800],
                              label: 'Nombre de crédits',
                              readonly: _ctx.readOnly,
                              density: "compact"
                            }, null, 8, ["modelValue", "readonly"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_divider)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-space-between py-2"
                    }, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "Total", -1)),
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.formatCurrency(_ctx.amount)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_ctx.withoutCredits)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": "",
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "pl-2 d-flex align-center",
              cols: "9"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  style: _normalizeStyle(_ctx.readOnly ? 'color:#EC6D56; font-weight:bold' : '')
                }, "Nombre de crédit(s) de paiement restant : " + _toDisplayString(_ctx.availablePaymentCreditCount), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "3",
              class: "py-0 d-flex justify-end"
            }, {
              default: _withCtx(() => [
                (_ctx.availablePaymentCreditCount <= 0 && _ctx.paymentType !== 'PAYMENT_CREDIT')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "red",
                      elevation: "0",
                      onClick: _ctx.setPaymentCreditMode,
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" Ajouter des crédits ")
                      ])),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4))
}